import { Component } from 'react'
import classnames from 'classnames'
import { route } from 'preact-router'
import { connect } from 'react-redux'
import { getP } from 'redux-polyglot'

import { selectAddonAndClear } from 'actions/addons'
import { openChannelGuide } from 'actions/channels'
import { selectPackageAndClear } from 'actions/packages'
import auth from 'libs/auth'
import { formatPrice } from 'libs/price'

import {
  dvrModuleEnabled,
  selectCheckoutModuleEnabled,
  selectRemoveRegister,
} from 'selectors/app'
import { getChannelById, getChannelPackages } from 'selectors/channels'
import { getVideo } from 'selectors/video'
import DefaultImg from '../../img/bg-circles-blue.jpg'
import styles from './paywall.css'

class Paywall extends Component {
  constructor(props) {
    super(props)
    let focused
    if (auth.isLoggedIn()) {
      if (this.props.checkoutModule) {
        focused = 'leftBtn'
      } else {
        focused = 'rightBtn'
      }
    } else {
      focused = 'leftBtn'
    }
    this.state = {
      focused: focused,
      focusedPos: 0,
    }
  }

  render({ polyglot: { t } }) {
    if (!this.props.channel) {
      return null
    }

    let title,
      content = ''
    if (
      this.props.packages.length === 1 &&
      !(this.props.channel.premium && this.props.channel.premium.offersPage)
    ) {
      const currentPackage = this.props.packages[0]
      if (this.props.video) {
        title = t('tv_paywall.video_purchase_from_package_title', {
          _:
            '<em>%{video}</em> requires a subscription to channel <em>%{channel}</em>, which is available with package <em>%{package}</em>. Purchase this package for %{price}.',
          video: this._getVideoNameTruncated(),
          channel: this.props.channel.name,
          package: currentPackage.name,
          price: formatPrice(currentPackage, t),
        })
      } else {
        title = t('tv_paywall.purchase_from_package_title', {
          _:
            '%{channel} is available with package %{package}. Purchase this package for %{price}.',
          channel: this.props.channel.name,
          package: currentPackage.name,
          price: formatPrice(currentPackage, t),
        })
      }

      content = this._renderPackageDetails(currentPackage)
    } else if (this.props.packages.length === 0) {
      if (this.props.channel.premium && this.props.channel.premium.offersPage) {
        if (this.props.video) {
          title = t('tv_paywall.video_purchase_premium_addon_title', {
            _:
              '<em>%{video}</em> requires a subscription to channel <em>%{channel}</em>, which is available as a premium Add-On. Purchase this channel for %{price}.',
            video: this._getVideoNameTruncated(),
            channel: this.props.channel.name,
            price: formatPrice(this.props.channel.premium, t),
          })
        } else {
          title = t('tv_paywall.purchase_premium_addon_title', {
            _:
              '%{channel} is available as a premium Add-On. Purchase this channel for %{price}.',
            channel: this.props.channel.name,
            price: formatPrice(this.props.channel.premium, t),
          })
        }

        if (this.props.channel.premium.videoCount >= 8) {
          content = this._renderPremiumDetails()
        } else {
          content = this._renderPremiumDetailsSimple()
        }
      } else {
        if (this.props.video) {
          title = t('tv_paywall.video_purchase_not_available_title', {
            _:
              '<em>%{video}</em> is not longer available for purchase. Check all other offers below.',
            video: this._getVideoNameTruncated(),
          })
        } else {
          title = t('tv_paywall.purchase_not_available_title', {
            _:
              '<em>%{channel}</em> is not longer available for purchase. Check all other offers below.',
            channel: this.props.channel.name,
          })
        }
      }
    } else {
      if (this.props.video) {
        title = t('tv_paywall.video_purchase_multiple_options_title', {
          _:
            '<em>%{video}</em> requires a subscription to channel <em>%{channel}</em>, which is available with these Packages and Add-Ons:',
          video: this._getVideoNameTruncated(),
          channel: this.props.channel.name,
        })
      } else {
        title = t('tv_paywall.purchase_multiple_options_title', {
          _: '%{channel} is available with these Packages and Add-Ons:',
          channel: this.props.channel.name,
        })
      }

      content = this._renderOptionsList()
    }

    let total = this.props.packages.length
    if (this.props.channel.premium && this.props.channel.premium.offersPage) {
      total = total + 1
    }

    const buttons = []
    if (auth.isLoggedIn()) {
      if (this.props.checkoutModule) {
        if (
          this.props.packages.length === 1 &&
          !(this.props.channel.premium && this.props.channel.premium.offersPage)
        ) {
          buttons.push(
            <div
              className={classnames(
                styles.paywallBtn,
                styles.loginBtn,
                'btn btnIcon btnIconTop'
              )}
              onClick={this._pkgAddToCart(this.props.packages[0])}
            >
              <span className="cart"></span>{' '}
              {t('tv_paywall.button_add_to_cart', { _: 'Add to Cart' })}
            </div>
          )
          buttons.push(
            <div
              className={classnames(
                'btn btnIcon btnIconTop',
                styles.paywallBtn,
                styles.loginBtn
              )}
              onClick={() =>
                route(
                  `${__webpack_public_path__ ||
                    '/'}checkout/packages?${this._getSourceQuery(
                    this.props.packages[0].id
                  )}`
                )
              }
            >
              <span className="info"></span>{' '}
              {t('tv_paywall.button_package_details', { _: 'Package Details' })}
            </div>
          )
        } else if (
          this.props.packages.length === 0 &&
          this.props.channel.premium &&
          this.props.channel.premium.offersPage
        ) {
          buttons.push(
            <div
              className={classnames(
                'btn btnIcon btnIconTop',
                styles.paywallBtn,
                styles.loginBtn
              )}
              onClick={this._addonAddToCart(this.props.channel)}
            >
              <span className="cart"></span>{' '}
              {t('tv_paywall.button_add_to_cart', { _: 'Add to Cart' })}
            </div>
          )
          buttons.push(
            <div
              className={classnames(
                'btn btnIcon btnIconTop',
                styles.paywallBtn,
                styles.loginBtn
              )}
              onClick={() =>
                route(
                  `${__webpack_public_path__ ||
                    '/'}checkout/addons?${this._getSourceQuery(
                    null,
                    this.props.channel.id
                  )}`
                )
              }
            >
              <span className="info"></span>{' '}
              {t('tv_paywall.button_addon_details', { _: 'Add-On Details' })}
            </div>
          )
        } else {
          buttons.push(
            <div
              className={classnames(
                'btn btnIcon btnIconTop',
                styles.paywallBtn,
                styles.loginBtn
              )}
              onClick={() =>
                route(
                  `${__webpack_public_path__ ||
                    '/'}checkout/packages?${this._getSourceQuery()}`
                )
              }
            >
              <span className="cart"></span>{' '}
              {t('tv_paywall.check_offers', { _: 'Check all Other Offers' })}
            </div>
          )
        }
      }
      buttons.push(
        <div
          className={`btn btnIcon ${styles.paywallBtn}`}
          onClick={() => {
            if (this.props.video) {
              this._backToVideoDetails()
            } else {
              this.props.openChannelGuide()
              if (this.props.isGuide) {
                route(`${__webpack_public_path__ || '/'}live`)
              } else window.history.back()
            }
          }}
        >
          <span className="remove"></span>{' '}
          {t('tv_paywall.reject_paywall', { _: 'No Thanks' })}
        </div>
      )
    } else {
      buttons.push(
        <div
          className={`${styles.paywallBtn} btn btnIcon`}
          onClick={() =>
            route(`${__webpack_public_path__ || '/'}auth/login?${this._getSourceQuery()}`)
          }
        >
          <span className="login"></span> {t('tv_paywall.button_login', { _: 'Login' })}
        </div>
      )
      if (!this.props.removeRegister) {
        buttons.push(
          <div
            className={`${styles.paywallBtn} btn btnIcon`}
            onClick={() =>
              route(
                `${__webpack_public_path__ || '/'}auth/register?${this._getSourceQuery()}`
              )
            }
          >
            <span className="signup"></span>{' '}
            {t('tv_paywall.button_register', { _: 'Register' })}
          </div>
        )
      }
    }

    const { video = {} } = this.props

    const bgImage = {
      backgroundImage: video && video.img ? `url(${video.img})` : `url(${DefaultImg})`,
    }

    return (
      <div className={`componentBody ${styles['paywall-block']}`} style={bgImage}>
        <div className={styles['paywall-block__container']}>
          <div className={styles['paywall-block__img']}>
            <img src={this.props.channel.img} alt="" />
          </div>
          <div
            className={styles['paywall-block__title']}
            dangerouslySetInnerHTML={{ __html: title }}
          />
          {content && content}
          <div className={styles['paywall-block__btn-group']}>{buttons}</div>
        </div>
      </div>
    )
  }

  _renderPackageDetails = currentPackage => {
    const {
      polyglot: { t },
    } = this.props

    let channels = []

    const line1 = []
    for (let i = 0; i < Math.min(4, currentPackage.channels.length); i++) {
      const channel = currentPackage.channels[i]
      line1.push(
        <div className={styles.channel}>
          <div className={styles['channel-wrapper']}>
            <figure className={styles['channel-img']}>
              <img src={channel.img} alt="" />
            </figure>
          </div>
        </div>
      )
    }
    if (line1.length > 0) {
      channels.push(<div className={classnames('clearfix', styles.line)}>{line1}</div>)
    }

    const line2 = []
    if (currentPackage.channels.length > 4) {
      for (let i = 4; i < Math.min(8, currentPackage.channels.length); i++) {
        const channel = currentPackage.channels[i]
        line2.push(
          <div className={styles.channel}>
            <div className={styles['channel-wrapper']}>
              <figure className={styles['channel-img']}>
                <img src={channel.img} alt="" />
              </figure>
            </div>
          </div>
        )
      }
      if (line2.length > 0) {
        channels.push(<div className={classnames('clearfix', styles.line)}>{line2}</div>)
      }
    }

    let message = ''
    if (currentPackage.count > 15) {
      const roundCount = Math.floor(currentPackage.count / 5) * 5
      if (currentPackage.count > roundCount) {
        message = t('tv_paywall.label_package_channels_available_plus', {
          _: '%{count}+ TV channels',
          count: roundCount,
        })
      } else {
        message = t('tv_paywall.label_package_channels_available_exact', {
          _: '%{count} TV channels',
          count: roundCount,
        })
      }
    } else {
      message = t('tv_paywall.label_package_channels_available_exact', {
        _: '%{count} TV channels',
        count: currentPackage.count,
      })
    }

    return (
      <div className={styles.columns}>
        <div className={styles.columnLeft}>
          <div className={styles.columnLeftFeature}>{message}</div>
          {this.props.dvrModuleEnabled && (
            <div className={styles.columnLeftFeature}>
              {t('tv_paywall.feature_dvr', { _: 'Unlimited DVR' })}
            </div>
          )}
          <div className={styles.columnLeftFeature}>
            {t('tv_paywall.feature_devices', { _: 'Works with major devices' })}
          </div>
          <div className={styles.columnLeftFeature}>
            {t('tv_paywall.feature_cancel_anytime', { _: 'Cancel anytime' })}
          </div>
        </div>
        <div className={styles.columnRight}>
          <div className={styles.columnRightTitle}>
            {t('tv_paywall.include_channels_title', {
              _: 'Includes top channels like:',
            })}
          </div>
          <div className={styles.columnRightChannels}>{channels}</div>
        </div>
      </div>
    )
  }

  _renderOptionsList = () => {
    let total = this.props.packages.length
    if (this.props.channel.premium && this.props.channel.premium.offersPage) {
      total = total + 1
    }

    if (!total) {
      return null
    }

    let start = this.state.focusedPos < 2 ? 0 : this.state.focusedPos - 2
    if (total > 2 && start > total - 2) {
      start = total - 2
    }
    let end = start + 3
    if (end > total) {
      end = total
    }

    const {
      polyglot: { t },
    } = this.props
    const items = []

    for (let i = start; i < end; i++) {
      if (typeof this.props.packages[i] !== 'undefined') {
        items.push(
          <div className={styles.subscriptionItem}>
            <div
              className={classnames('clearfix', styles.row, {
                [styles.first]: i === 0,
                [styles.last]: i === total - 1,
              })}
            >
              <div className={styles.itemThumb}>
                <img src={this.props.packages[i].img} alt="" />
              </div>
              <div className={classnames(styles.column, styles.columnTitle)}>
                <div className={styles.top}>{this.props.packages[i].name}</div>
                <div className={styles.bottom}>
                  {formatPrice(this.props.packages[i], t)}
                </div>
              </div>
              {auth.isLoggedIn() && this.props.checkoutModule && (
                <div className={styles['btn-action__group']}>
                  <div
                    className={classnames('btn btnIcon', styles.btnInfo)}
                    onClick={() =>
                      route(
                        `${__webpack_public_path__ ||
                          '/'}checkout/packages?${this._getSourceQuery(
                          this.props.packages[i].id
                        )}`
                      )
                    }
                  >
                    <span className="info" />
                  </div>
                  <div
                    className={classnames('btn btnIcon', styles.btnCart)}
                    onClick={this._pkgAddToCart(this.props.packages[i])}
                  >
                    <span className="cart"></span>{' '}
                    {t('tv_paywall.button_add_to_cart', { _: 'Add to Cart' })}
                  </div>
                </div>
              )}
            </div>
          </div>
        )
      } else if (
        i === total - 1 &&
        this.props.channel.premium &&
        this.props.channel.premium.offersPage
      ) {
        items.push(
          <div className={styles.subscriptionItem}>
            <div
              className={classnames('clearfix', styles.row, {
                [styles.first]: i === 0,
                [styles.last]: i === total - 1,
              })}
            >
              <div className={styles.itemThumb}>
                <img src={this.props.channel.img} alt="" />
              </div>
              <div className={classnames(styles.column, styles.columnTitle)}>
                <div className={styles.top}>
                  {t('tv_paywall.channel_addon_listing_title', {
                    _: '%{channel} Add-on',
                    channel: this.props.channel.name,
                  })}
                </div>
                <div className={styles.bottom}>
                  {formatPrice(this.props.channel.premium, t)}
                </div>
              </div>
              {auth.isLoggedIn() && this.props.checkoutModule && (
                <div className={styles['btn-action__group']}>
                  <div
                    className={classnames('btn btnIcon', styles.btnInfo)}
                    onClick={() =>
                      route(
                        `${__webpack_public_path__ ||
                          '/'}checkout/addons?${this._getSourceQuery(
                          null,
                          this.props.channel.id
                        )}`
                      )
                    }
                  >
                    <span className="info" />
                  </div>
                  <div
                    className={classnames('btn btnIcon', styles.btnCart)}
                    onClick={this._addonAddToCart(this.props.channel)}
                  >
                    <span className="cart"></span>{' '}
                    {t('tv_paywall.button_add_to_cart', { _: 'Add to Cart' })}
                  </div>
                </div>
              )}
            </div>
          </div>
        )
      }
    }

    const content = []
    if (items.length > 0) {
      if (total > 3) {
        content.push(
          <div
            className={classnames(styles.arrow, styles.arrowUp, {
              [styles.visible]: start > 0,
            })}
          >
            <span></span>
          </div>
        )
      }
      content.push(<div className={styles.list}>{items}</div>)
      if (total > 3) {
        content.push(
          <div
            className={classnames(styles.arrow, styles.arrowDown, {
              [styles.visible]: end < total,
            })}
          >
            <span></span>
          </div>
        )
      }
    }

    return content
  }

  _renderPremiumDetails = () => {
    const {
      polyglot: { t },
    } = this.props

    let videos = []

    const line1 = []
    for (let i = 0; i < Math.min(4, this.props.channel.premium.videos.length); i++) {
      const video = this.props.channel.premium.videos[i]
      line1.push(
        <div className={styles.channel}>
          <div className={styles['channel-wrapper']}>
            <figure className={styles['channel-img']}>
              <img src={video.img} alt="" />
            </figure>
          </div>
        </div>
      )
    }
    if (line1.length > 0) {
      videos.push(<div className={classnames('clearfix', styles.line)}>{line1}</div>)
    }

    const line2 = []
    if (this.props.channel.premium.videos.length > 4) {
      for (let i = 4; i < Math.min(8, this.props.channel.premium.videos.length); i++) {
        const video = this.props.channel.premium.videos[i]
        line2.push(
          <div className={styles.channel}>
            <div className={styles['channel-wrapper']}>
              <figure className={styles['channel-img']}>
                <img src={video.img} alt="" />
              </figure>
            </div>
          </div>
        )
      }
      if (line2.length > 0) {
        videos.push(<div className={classnames('clearfix', styles.line)}>{line2}</div>)
      }
    }

    let message = ''
    if (this.props.channel.premium.videoCount > 15) {
      const roundCount = Math.floor(this.props.channel.premium.videoCount / 5) * 5
      if (this.props.channel.premium.videoCount > roundCount) {
        message = t('tv_paywall.label_channel_videos_available_plus', {
          _: '%{count}+ Popular Movies',
          count: roundCount,
        })
      } else {
        message = t('tv_paywall.label_channel_videos_available_exact', {
          _: '%{count} Popular Movies',
          count: roundCount,
        })
      }
    } else {
      message = t('tv_paywall.label_channel_videos_available_plus', {
        _: '%{count}+ Popular Movies',
        count: this.props.channel.premium.videoCount,
      })
    }

    return (
      <div className={classnames(styles.columns, styles.columnsExtended)}>
        <div className={styles.columnLeft}>
          <div className={styles.columnLeftFeature}>{message}</div>
          <div className={styles.columnLeftFeature}>
            {t('tv_paywall.feature_devices', { _: 'Works with major devices' })}
          </div>
          <div className={styles.columnLeftFeature}>
            {t('tv_paywall.feature_cancel_anytime', { _: 'Cancel anytime' })}
          </div>
        </div>
        <div className={styles.columnRight}>
          <div className={styles.columnRightTitle}>
            {t('tv_paywall.include_videos_title', {
              _: 'Includes popular movies like:',
            })}
          </div>
          <div className={styles.columnRightChannels}>{videos}</div>
        </div>
      </div>
    )
  }

  _renderPremiumDetailsSimple = () => {
    const {
      polyglot: { t },
    } = this.props
    return (
      <div className={styles.columns}>
        <div
          className={classnames(styles.columnLeft, {
            [styles.columnLeftSingle]: !this.props.channel.premium.desc,
          })}
        >
          {this.props.dvrModuleEnabled && (
            <div className={styles.columnLeftFeature}>
              {t('tv_paywall.feature_dvr', { _: 'Unlimited DVR' })}
            </div>
          )}
          <div className={styles.columnLeftFeature}>
            {t('tv_paywall.feature_devices', { _: 'Works with major devices' })}
          </div>
          <div className={styles.columnLeftFeature}>
            {t('tv_paywall.feature_cancel_anytime', { _: 'Cancel anytime' })}
          </div>
        </div>
        {this.props.channel.premium.desc && (
          <div className={styles.columnRight}>
            <div className={styles.columnRightDesc}>
              {this.props.channel.premium.desc}
            </div>
          </div>
        )}
      </div>
    )
  }

  _getSourceQuery = (pkgId, channelId) => {
    let source = []
    if (this.props.video) {
      if (this.props.source && this.props.source.src) {
        source.push(`src=${this.props.source.src}`)
        if (this.props.source.ctgid) {
          source.push(`ctgid=${this.props.source.ctgid}`)
        }
        if (this.props.source.subid) {
          source.push(`subid=${this.props.source.subid}`)
        }
        if (this.props.source.tid) {
          source.push(`tid=${this.props.source.tid}`)
        }
      }
      source.push(`id=${this.props.video.id}`)
    } else {
      source.push(`src=live`)
    }
    if (pkgId) {
      source.push(`pkgid=${pkgId}`)
    } else if (channelId) {
      source.push(`chid=${channelId}`)
    }
    return source.join('&')
  }

  _backToVideoDetails = () => {
    this.props.onBack()
  }

  _getVideoNameTruncated = () => {
    return this.props.video.name.length > 50
      ? `${this.props.video.name.substring(0, 50)} ...`
      : this.props.video.name
  }

  _pkgAddToCart = pkg => () => {
    this.props.selectPackageAndClear(pkg.id, false).then(() => {
      route(
        `${__webpack_public_path__ || '/'}checkout/packages?${this._getSourceQuery(
          pkg.id
        )}`
      )
    })
  }

  _addonAddToCart = channel => () => {
    const addon = {
      id: channel.id,
      name: channel.name,
      description: '',
      price: channel.price,
      recurring: channel.premium.recurring,
      recurDetails: {
        length: channel.premium.recurDetails.length,
        type: channel.premium.recurDetails.type,
      },
      hasAccess: false,
      isSelected: false,
      type: channel.type === 'flixfling_channel' ? 'flixfling' : 'channel',
      itemType: 'premium',
      detailsRequested: false,
    }
    this.props.selectAddonAndClear(addon, false).then(() => {
      route(
        `${__webpack_public_path__ || '/'}checkout/addons?${this._getSourceQuery(
          null,
          this.props.channel.id
        )}`
      )
    })
  }
}

const mapStateToProps = (state, ownProps) => {
  const channelId = ownProps.id

  return {
    video:
      typeof ownProps.videoId !== 'undefined' && ownProps.videoId > 0
        ? getVideo(state)
        : undefined,
    channel: getChannelById(state, channelId),
    packages: getChannelPackages(state, channelId),
    polyglot: getP(state),
    checkoutModule: selectCheckoutModuleEnabled(state),
    removeRegister: selectRemoveRegister(state),
    dvrModuleEnabled: dvrModuleEnabled(state),
  }
}

const mapDispatchToProps = {
  selectPackageAndClear,
  selectAddonAndClear,
  openChannelGuide,
}

export default connect(mapStateToProps, mapDispatchToProps)(Paywall)
